export interface EditorPreferences {
  gridVisible: boolean;
  snapToGrid: boolean;
  gridSize: 10 | 20 | 40;
}

const KEY = 'owdex-draw:editor-preferences';
const DEFAULTS: EditorPreferences = { gridVisible: true, snapToGrid: true, gridSize: 10 };

export function defaultEditorPreferences(): EditorPreferences { return { ...DEFAULTS }; }

export function loadEditorPreferences(): EditorPreferences {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return DEFAULTS;
    const parsed = JSON.parse(raw) as Partial<EditorPreferences>;
    return {
      gridVisible: typeof parsed.gridVisible === 'boolean' ? parsed.gridVisible : DEFAULTS.gridVisible,
      snapToGrid: typeof parsed.snapToGrid === 'boolean' ? parsed.snapToGrid : DEFAULTS.snapToGrid,
      gridSize: [10, 20, 40].includes(Number(parsed.gridSize)) ? parsed.gridSize as 10 | 20 | 40 : DEFAULTS.gridSize,
    };
  } catch {
    return DEFAULTS;
  }
}

export function saveEditorPreferences(preferences: EditorPreferences): void {
  try { localStorage.setItem(KEY, JSON.stringify(preferences)); } catch { /* preferência não é crítica */ }
}
